import {fragments} from '@/gql';
const {gql} = require('graphql-tag');
export default gql`
  mutation createFilm ($input: FilmInput!) {
    createFilm(input: $input) {
      ...filmDetail
    }
  }
  ${fragments.filmDetail}
`;
